import { BannerPrimary } from '@sbercloud/uikit-product-site-banner';
import { SectionBasic } from '@sbercloud/uikit-product-site-section';
import { useRouter } from 'next/navigation';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';

export interface PromoBannerProps {
  id?: string;
  title?: string;
  description?: string;
  button?: {
    title?: string;
    link?: string;
  };
  onButtonClick?: () => void;
  className?: string;
}

export function PromoBanner({
  id,
  title,
  description,
  button,
  onButtonClick,
  className,
}: PromoBannerProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();
  const router = useRouter();

  return (
    <SectionBasic layoutType={layoutType} id={id}>
      <BannerPrimary
        className={className}
        title={title || ''}
        description={description}
        appearance="graphite"
        layoutType={layoutType}
        img="https://cdn.cloud.ru/backend/images/banners/bonuses.png"
        imgType="square"
        buttons={
          button
            ? [
                {
                  label: button.title,
                  href: button.link,
                  onClick(event) {
                    onButtonClick?.();
                    const link = button?.link;
                    const title = button?.title;

                    if (!link || !title) {
                      return;
                    }

                    event.preventDefault();

                    clickAnalytics({
                      action: link,
                      clickZone: 'body',
                      clickElement: 'button',
                      clickContent: title || 'unknown',
                      uniqueId: `PromoBanner-button-${title}`,
                      transitionType: 'inside-link',
                    });
                    router.push(link);
                  },
                },
              ]
            : undefined
        }
      />
    </SectionBasic>
  );
}
